<template>
	<div class="orderdetails-container">
		<div class="head">Order details</div>
		<div class="wrap">
			<div class="title">
				<span>SN：{{order.order_sn}}</span>
				<span>{{moment(order.time*1000).format('MMMM DD,YYYY  HH:mm')}}</span>
			</div>
			<h6 class="order-title">
				<!-- 待付款 -->
				<p v-if="order.status==1&&order.pay_type!=6">To pay</p>
				<p v-if="order.status==1&&order.pay_type==6">线下支付</p>
				<!-- 待发货 -->
				<p v-if="order.status==2">To ship（Your order will be ready in 15 working days.）</p>
				<p v-if="order.status==3">Goods Undelivered Order</p>
				<!--  已完成 -->
				<p v-if="order.status==4">Finished</p>
			</h6>
			<h5 class="">Commodity information</h5>
			<div class="list-item">
				<div class="img">
					<img :src="order.goods_img" />
				</div>
				<div class="name">
				      <p> {{order.goods_name}}</p>

				      <p> <label>Size：</label><span> {{order.code}}</span> </p>

				      <p class="web-element"> <label>num：</label><span> {{order.num}}</span> </p>

				</div>
				<div class="num pc-element">x {{order.num}}</div>
				<div class="price">$ {{order.price}}</div>
			</div>
			<div class="address-item">
				<h4> Information</h4>
				<ul>
                   
					<li><label>Consignee：</label><span>{{order.first_name}} {{order.last_name}}</span></li>
					<li><label>Email：</label><span>{{order.email}}</span></li>
					<li><label>Phone：</label><span>{{order.phone}}</span></li>
					<li><label>Address：</label><span>{{order.country}}{{order.address}}</span></li>
					<li><label>Postcode：</label><span>{{order.postcode}}</span></li>
				</ul>
			</div>
			<div class="logistics-item" v-if="order.status!=1">
                <!-- 物流信息 -->
				<h4>Logistics</h4>
                <!-- {{orderDetails.express_text}} -->
				<template v-if="order.express_text">
					<el-timeline>
						<el-timeline-item v-for="(activity, index) in order.express_text.data" :key="index" :icon="activity.icon" 
						     :type="activity.type"
						     :color="activity.color" size="large">
							 {{activity.time}} {{activity.context}}
						</el-timeline-item>
					</el-timeline>
				</template>
			</div>
            <custable :order="order" :category="category" v-if="finishFlag"></custable>

			<div class="payment-mode" v-if="order.status==1">
				<div class="item" v-if="order.pay_type == 5">
					<img src="../assets/pp.png">
				</div>
				<div class="item" v-else>
					<img src="../assets/stripe.png">
				</div>
			</div>
			<div class="totle-item">
				<ul>
					<!-- <li>
						<label>Disbursements：</label>
						<span>
							<i class="red">$ {{order.price}}</i>
						</span>
					</li> -->
					<li>
						<label>Num：</label><span>x {{order.num}}</span>
					</li>
					<li>
						
						<label> Total：</label><span> $ {{order.price}}</span>
					</li>
					<li v-if="order.status==1">					
						<el-button type="success" :loading="loading" @click="confirm">Pay
						</el-button>
					</li>
				</ul>
			</div>

		</div>
	</div>
</template>

<script>


	import custable from "@/components/custable";


	export default {
		data() {
			return {
				order:{},
				category:[],
				order_id:0,
				formDate: {
					type: 5,
				},
				finishFlag:false,
				shapeprice: this.global_variable.shapeprice,
				loading:false,
			}
		},
		components:{
           custable,
		},
		mounted() {

			this.order_id = this.$route.params.id;

         this.init();
		},
		methods: {
			init(){
               this.getOrderDetails();
			},
			getGoodsCategory(goods_id) {

				var app = this;

				app.$api("/index/getGoodsCategory", {
					goods_id

				}).then(function(res) {

					app.category = res.data.list[0].category;
					
				})
			},
			getGoodsDetail(goods_id,shapetwo){

                var app = this;

	            this.$api("/index/getGoodsDetail",{id:goods_id}).then(function(res) {

	            	console.log(res)
	                if(res.data.here!=shapetwo){
	                  app.$set(app.order,"shapeprice",app.shapeprice)
	                }else{
	                   app.$set(app.order,"shapeprice",0)
	                }
	                  
	                app.$set(app.order,"originalprice",res.data.price)
	                
	                res.data.here_list.forEach(item=>{
	                	if(item.id==app.order.shapetwo){
	                		 app.$set(app.order,"shapetwoValue",item.name)
	                	}
	                })

	                
	                app.finishFlag = true;
	            })
			},
			getOrderDetails(){

                var app = this;

                this.$api("/user/getOrderDetails",{order_id:this.order_id}).then(function(res) {

                       app.order  = res.data;

                       app.order.size = JSON.parse(res.data.data);
                       app.order.embroidery = JSON.parse(res.data.embroidery);
                       app.order.title = res.data.goods_name;

                       app.getGoodsCategory(res.data.goods_id);
                       app.getGoodsDetail(res.data.goods_id,res.data.shapetwo)


                       if(app.order.express_text){

                          app.order.express_text.data.forEach( item => {
	                       	   if( moment(item.time).valueOf() - new Date().getTime() < 0 ){
	                               item.color = "#0bbd87"
	                       	   }
	                       })
                       }
				})

			},

			confirm(){
              
               var app = this;

               app.loading = true;
			   var url
				if(app.order.pay_type == 5){
					url = "/paypal/index"
				}
				else{
					url = "/pay_stripe/index"
				}
               app.$api(url,{order_id:app.order_id},"post").then(function(res) {
			   	 
					   app.loading = false;

					   if (res.status == "200") {

					 	     window.open(res.data.url);
				       }

				})

			}
		}
	}
</script>

<style lang="less">
    .el-button--success{
		background-color: #90c31f;
		border-color: #90c31f;
    }
    .el-button--success:hover{
    	background-color: #8dc513;
		border-color:#8dc513;
    }
	.orderdetails-container {
		.payment-mode {
			padding:40px 0;
			border-bottom: 1px solid #dcdddd;
			.title {
				margin-bottom: 42px;
				font-size: 20px;
				font-weight: bold;
			}
			.mode {
				display: flex;
				align-items: center;
				.item {
					padding: 0 40px;
					line-height: 78px;
					margin-right: 20px;
					border: 1px solid #dcdddd;
					border-radius: 6px;
					overflow: hidden;
					cursor: pointer;
					font-size: 24px;

					i {
						font-size: 40px;
					}
				}
				.item.on {
					border-color: #90c31f;
				}
				.item:nth-last-child(1) {
					margin-right: 0;
				}
			}
		}
		

		.wrap {
			.title {
				display: flex;
				font-size: 16px;
				color: #fff;
				padding: 0 30px;
				line-height: 50px;
				background-color: #90c31f;
				justify-content: space-between;
			}

			.order-title {
				color: #90c31f;
				font-size: 20px;
				line-height: 80px;
				font-weight: bold;
				height:80px;
			}

			h5 {
				font-size: 16px;
				color: #666666;
				line-height: 50px;
				padding-left: 20px;
				background-color: #f7f8f8;
			}
			.totle-item {
				padding: 40px 0;
				text-align:right;
				color: #666666;
				ul {
					li {
						>span{
							display: inline-block;
							width: 100px;
						}
						margin-bottom: 20px;
						.red{
							color: #e82323;
						}
					}
				}
			}
			.logistics-item {
				padding: 40px 0;
				line-height: 1.4;
				border-bottom: 1px solid #dcdddd;
				h4 {
					color: #666666;
					font-size: 20px;
					margin-bottom: 40px;
				}
			}

			.address-item {
				padding: 40px 0;
				line-height: 1.4;
				padding-bottom:30px;

				h4 {
					font-size: 20px;
					font-weight:bold;
					margin-bottom: 30px;
				}

				ul {
					li {
						margin-bottom: 14px;

						label {
							width: 100px;
							text-align: justify;
							display: inline-block;
						}

						&:last-child {
							margin-bottom: 0;
						}
					}
				}

			}

			.list-item {
				padding: 40px 0;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #dcdddd;

				.img {
					flex: 0 0 140px;
					img {
						width: 140px;
					}
				}

				.name {
					font-size: 16px;
					color: #0f0e0e;
					flex: 1;
					padding-left:20px;
					line-height:1.6;
					text-align: left;
					label,span{
						color:#999999;
					}
				}

				.num {
					color: #999999;
					flex: 1;
					text-align: center;
				}

				.price {
					font-size: 18px;
					color: #0f0e0e;
				}
			}
		}
	}

	@media screen and (max-width:768px) {

		.orderdetails-container{
			
			.wrap{
				padding-left:0;
				.title{
					font-size:12px;
					padding:0 4%;
					line-height:36px;
				}
				h5{
					line-height:36px;
					font-size:12px;
					padding-left:10px;
				}
				.payment-mode{
					display:none;
				}
				.totle-item{
					padding:20px 0;
					font-size:12px;
					ul{
						li{
							margin-bottom:10px;
							.primary-button{
								font-size:12px;
								width:100px;
								line-height:40px;
							}
							
						}
					}
				}
				.address-item{
					padding:20px 0;
					font-size:12px;
					h4{
						font-size:14px;
						margin-bottom:10px;
					}
				}
				.logistics-item{
				   padding: 20px 0;
				   font-size: 12px;
                   h4{
						font-size:14px;
						margin-bottom:10px;
					}  
				}
				.list-item{
					padding: 20px 0;
					font-size:12px;
					.price{
						font-size:12px;
					}
					.name{
						font-size:12px;
					}
					.img{
						flex:0 0 70px;
						img{
							width:100%;
						}
					}
				}
				.order-title{
					 line-height:50px;
					 height:50px;
					 font-size:14px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Orderdetails.vue